import { createDomain } from 'effector';

const domain = createDomain('core-user/task-feedback');

if (process.env.NODE_ENV === 'development') {
    // @ts-ignore
    import('effector-logger/attach').then((module) => module.attachLogger(domain));
}

export default domain;
